var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8791 8.37478L8.39309 13.8608C7.56709 14.6868 7.56709 16.0268 8.39309 16.8528V16.8528C9.21909 17.6788 10.5591 17.6788 11.3851 16.8528L18.6171 9.62079C20.1321 8.10579 20.1321 5.64979 18.6171 4.13479V4.13479C17.1021 2.61979 14.6461 2.61979 13.1311 4.13479L5.89909 11.3668C3.69509 13.5708 3.69509 17.1428 5.89909 19.3468V19.3468C8.10309 21.5508 11.6751 21.5508 13.8791 19.3468L18.2681 14.9578",
    stroke: "#36BFFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentBlue);
export default __webpack_public_path__ + "static/media/attachment-blue.344a5090a4540fa23ef9cd63da18f89d.svg";
export { ForwardRef as ReactComponent };